import axios from "axios";
import * as Constants from "../../../constants/Constants";
import { refreshMasterAdminToken } from "../MasterAdminService";

export function getAllLocationsForPOSMasterAdmin() {
  return new Promise(async (resolve, reject) => {
    let ttltimeCheck = await refreshMasterAdminToken();
    let token = localStorage.getItem("master-token");
    await axios
      .get(
        Constants.REACT_APP_API_URL +
          process.env.REACT_APP_API_VERSION +
          Constants.POS_GET_LOCATIONS_API_ROUTE,
        {
          headers: {
            "content-type": Constants.CONTANT_TYPE,
            Authorization: "Bearer" + token,
            Permission: Constants.POS_CREATE_API_PERMISSION,
          },
        }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        let errorData = {
          error: true,
          response: error.response,
          code: error.code,
        };
        resolve(errorData);
      });
  });
}

export function getAllLocationsForPOSMasterAdminList() {
  return new Promise(async (resolve, reject) => {
    let ttltimeCheck = await refreshMasterAdminToken();
    let token = localStorage.getItem("master-token");
    await axios
      .get(
        Constants.REACT_APP_API_URL +
          process.env.REACT_APP_API_VERSION +
          Constants.POS_GET_LOCATIONS_API_ROUTE,
        {
          headers: {
            "content-type": Constants.CONTANT_TYPE,
            Authorization: "Bearer" + token,
            Permission: Constants.POS_LIST_API_PERMISSION,
          },
        }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        let errorData = {
          error: true,
          response: error.response,
          code: error.code,
        };
        resolve(errorData);
      });
  });
}

export function getAllPosMasterAdmin(payload) {
  return new Promise(async (resolve, reject) => {
    let ttltimeCheck = await refreshMasterAdminToken();
    let token = localStorage.getItem("master-token");
    await axios
      .post(
        Constants.REACT_APP_API_URL +
          process.env.REACT_APP_API_VERSION +
          Constants.POS_LIST_API_ROUTE,
        payload,
        {
          headers: {
            "content-type": Constants.CONTANT_TYPE,
            Authorization: "Bearer" + token,
            Permission: Constants.POS_LIST_API_PERMISSION,
          },
        }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function posCreateMasterAdmin({ request, params }) {
  return new Promise(async (resolve, reject) => {
    let ttltimeCheck = await refreshMasterAdminToken();
    let token = localStorage.getItem("master-token");
    let formData = await request.formData();
    const payload = JSON.stringify({
      name: Object.fromEntries(formData).name,
      location_id: Object.fromEntries(formData).location_id,
    });
    await axios
      .post(
        Constants.REACT_APP_API_URL +
          process.env.REACT_APP_API_VERSION +
          Constants.POS_CREATE_API_ROUTE,
        payload,
        {
          headers: {
            "content-type": Constants.CONTANT_TYPE,
            Authorization: "Bearer" + token,
            Permission: Constants.POS_CREATE_API_PERMISSION,
          },
        }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        let errorData = {
          error: true,
          response: error.response,
          code: error.code,
        };
        resolve(errorData);
      });
  });
}

export function posUpdateMasterAdmin({ request, params }) {
  return new Promise(async (resolve, reject) => {
    let ttltimeCheck = await refreshMasterAdminToken();
    let token = localStorage.getItem("master-token");
    const id = params.id;
    let formData = await request.formData();
    const payload = JSON.stringify({
      name: Object.fromEntries(formData).name,
      location_id: Object.fromEntries(formData).location_id,
    });
    await axios
      .put(
        Constants.REACT_APP_API_URL +
          process.env.REACT_APP_API_VERSION +
          Constants.POS_EDIT_API_ROUTE +
          `/${id}`,
        payload,
        {
          headers: {
            "content-type": Constants.CONTANT_TYPE,
            Authorization: "Bearer" + token,
            Permission: Constants.POS_EDIT_API_PERMISSION,
          },
        }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        let errorData = {
          error: true,
          response: error.response,
          code: error.code,
        };
        resolve(errorData);
      });
  });
}

export function getPosStationMasterAdmin({ request, params }) {
  return new Promise(async (resolve, reject) => {
    const id = params.id;
    let ttltimeCheck = await refreshMasterAdminToken();
    let token = localStorage.getItem("master-token");
    await axios
      .get(
        Constants.REACT_APP_API_URL +
          process.env.REACT_APP_API_VERSION +
          `${Constants.POS_EDIT_GET_DATA_API_ROUTE + "/" + id + "/edit"}`,
        {
          headers: {
            "content-type": Constants.CONTANT_TYPE,
            Authorization: "Bearer" + token,
            Permission: Constants.POS_EDIT_API_PERMISSION,
          },
        }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        let errorData = {
          error: true,
          response: error.response,
          code: error.code,
        };
        resolve(errorData);
      });
  });
}

export function getPosSettingsMasterAdmin({ request, params }) {
  return new Promise(async (resolve, reject) => {
    const id = params.id;
    let ttltimeCheck = await refreshMasterAdminToken();
    let token = localStorage.getItem("master-token");
    await axios
      .get(
        Constants.REACT_APP_API_URL +
          process.env.REACT_APP_API_VERSION +
          `${Constants.POS_EDIT_API_ROUTE_SETTING + "/" + id}`,
        {
          headers: {
            "content-type": Constants.CONTANT_TYPE,
            Authorization: "Bearer" + token,
            Permission: Constants.POS_EDIT_SETTINGS_API_PERMISSION,
          },
        }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        let errorData = {
          error: true,
          response: error.response,
          code: error.code,
        };
        resolve(errorData);
      });
  });
}

export function updatePosSettingsMasterAdmin({ request, params }) {
  return new Promise(async (resolve, reject) => {
    let ttltimeCheck = await refreshMasterAdminToken();
    let token = localStorage.getItem("master-token");
    const id = params.id;
    let formData = await request.formData();
    const payload = {
      name: Object.fromEntries(formData).name,
      location_id: Object.fromEntries(formData).location_id,
      pos_station_id: id,
      // key:Object.fromEntries(formData).allValue
    };
    if (Object.fromEntries(formData).hasOwnProperty("allValue")) {
      payload.key = JSON.parse(Object.fromEntries(formData).allValue);
    }
    await axios
      .put(
        Constants.REACT_APP_API_URL +
          process.env.REACT_APP_API_VERSION +
          Constants.POS_UPDATE_SETTING_API_ROUTE_SETTING +
          `/${id}`,
        payload,
        {
          headers: {
            "content-type": Constants.CONTANT_TYPE,
            Authorization: "Bearer" + token,
            Permission: Constants.POS_EDIT_API_PERMISSION,
          },
        }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        let errorData = {
          error: true,
          response: error.response,
          code: error.code,
        };
        resolve(errorData);
      });
  });
}

export function getPosSettingsViewMasterAdmin({ request, params }) {
  return new Promise(async (resolve, reject) => {
    const id = params.id;
    let ttltimeCheck = await refreshMasterAdminToken();
    let token = localStorage.getItem("master-token");
    await axios
      .get(
        Constants.REACT_APP_API_URL +
          process.env.REACT_APP_API_VERSION +
          `${Constants.POS_SETTING_VIEW_API_ROUTE_SETTING + "/" + id}`,
        {
          headers: {
            "content-type": Constants.CONTANT_TYPE,
            Authorization: "Bearer" + token,
            Permission: Constants.POS_EDIT_SETTINGS_API_PERMISSION,
          },
        }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        let errorData = {
          error: true,
          response: error.response,
          code: error.code,
        };
        resolve(errorData);
      });
  });
}

export function posDeactiveReactiveMasterAdmin({ request, params }) {
  return new Promise(async (resolve, reject) => {
    let ttltimeCheck = await refreshMasterAdminToken();
    let token = localStorage.getItem("master-token");
    let formData = await request.formData();
    if (Object.fromEntries(formData).type == Constants.DEACTIVE) {
      let id = Object.fromEntries(formData).id;
      await axios
        .delete(
          Constants.REACT_APP_API_URL +
            process.env.REACT_APP_API_VERSION +
            Constants.POS_DEACTIVATE_API_ROUTE +
            "/" +
            id,
          {
            headers: {
              "content-type": Constants.CONTANT_TYPE,
              Authorization: "Bearer" + token,
              Permission: Constants.POS_DEACTIVATE_PERMISSION,
            },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          let errorData = {
            error: true,
            response: error.response,
            code: error.code,
          };
          resolve(errorData);
        });
    } else if (Object.fromEntries(formData).type == Constants.REACTIVE) {
      let id = Object.fromEntries(formData).id;
      await axios
        .post(
          Constants.REACT_APP_API_URL +
            process.env.REACT_APP_API_VERSION +
            Constants.POS_REACTIVATE_API_ROUTE +
            "/" +
            id,
          {},
          {
            headers: {
              "content-type": Constants.CONTANT_TYPE,
              Authorization: "Bearer" + token,
              Permission: Constants.POS_REACTIVATE_PERMISSION,
            },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          let errorData = {
            error: true,
            response: error.response,
            code: error.code,
          };
          resolve(errorData);
        });
    }
  });
}

export function getAllDeactivePosMasterAdmin(payload) {
  return new Promise(async (resolve, reject) => {
    let ttltimeCheck = await refreshMasterAdminToken();
    let token = localStorage.getItem("master-token");
    await axios
      .post(
        Constants.REACT_APP_API_URL +
          process.env.REACT_APP_API_VERSION +
          Constants.POS_DEACTIVATE_LIST_API_ROUTE,
        payload,
        {
          headers: {
            "content-type": Constants.CONTANT_TYPE,
            Authorization: "Bearer" + token,
            Permission: Constants.POS_DEACTIVATE_PERMISSION,
          },
        }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function duplicatePosSettingsMasterAdmin({ request, params }) {
  return new Promise(async (resolve, reject) => {
    let ttltimeCheck = await refreshMasterAdminToken();
    let token = localStorage.getItem("master-token");
    const id = params.id;
    let formData = await request.formData();
    const payload = {
      name: Object.fromEntries(formData).name,
      location_id: Object.fromEntries(formData).location_id,
      pos_station_id: id,
      // key:Object.fromEntries(formData).allValue
    };
    if (Object.fromEntries(formData).hasOwnProperty("allValue")) {
      payload.key = JSON.parse(Object.fromEntries(formData).allValue);
    }
    if (Object.fromEntries(formData).hasOwnProperty("secondPrintTypes")) {
      payload.secondPrintTypes = JSON.parse(Object.fromEntries(formData).secondPrintTypes);
    }
    await axios
      .post(
        Constants.REACT_APP_API_URL +
          process.env.REACT_APP_API_VERSION +
          Constants.POS_SETTING_DUPLICATE_API_ROUTE,
        payload,
        {
          headers: {
            "content-type": Constants.CONTANT_TYPE,
            Authorization: "Bearer" + token,
            Permission: Constants.POS_EDIT_API_PERMISSION, // change when new permission create POS_SETTING_DUPLICATE_PERMISSION
          },
        }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        let errorData = {
          error: true,
          response: error.response,
          code: error.code,
        };
        resolve(errorData);
      });
  });
}
export function getPrintersList(payload) {
  return new Promise(async (resolve, reject) => {
    let token = localStorage.getItem("token");
    axios
      .post(
        Constants.REACT_APP_API_URL +
          process.env.REACT_APP_API_VERSION +
          Constants.GET_LARGE_PRINTERS_API_PATH,
        payload,
        {
          headers: {
            "content-type": Constants.CONTANT_TYPE,
            Authorization: "Bearer" + token,
            Permission: Constants.POS_EDIT_SETTINGS_API_PERMISSION,
          },
        }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

